import { constants as insightsConstants } from 'mage-insights'
import { connect } from 'react-redux'

export default connect(null, (dispatch, { category, action, label }) => ({
  track: data =>
    dispatch({
      type: 'EDUCATION_INSIGHTS_TRACKING',
      meta: {
        [insightsConstants.INSIGHTS_EVENT]: {
          category,
          action,
          label,
          ...data
        }
      }
    })
}))
